// Peças comuns dos módulos de endpoint do metrics.
//
// O prefixo mora AQUI e em nenhum outro lugar: a rota do back é `/v1/metricas/`
// (PT-BR) enquanto os nomes dos endpoints RTK Query são `metrics*` (EN) — a
// arbitragem da Parte 4 do plano. Espalhar a string `metricas` por 7 arquivos
// garantiria que um deles ficasse para trás numa renomeação.
import { qs } from '@/lib/api/qs';
import type { MetricsFilterArgs } from '../slice';

/** Prefixo das rotas do módulo (o baseQuery já provê `/api/v1`). */
export const METRICS_PREFIX = '/metricas';

/** Args de qualquer leitura agregada. */
export type MetricsQueryArgs = MetricsFilterArgs;

/** `+ segmentBy` — endpoints que devolvem `Segmented`. */
export interface MetricsSegmentArgs extends MetricsFilterArgs {
  segmentBy?: string;
}

/** `+ cursor/limit` — drill-downs (cursor, nunca OFFSET). */
export interface MetricsListArgs extends MetricsFilterArgs {
  cursor?: string;
  /** 1..100, default 20 no back. */
  limit?: number;
}

/**
 * Monta a URL de um endpoint do módulo. Passa os args direto pelo `qs`, que já
 * descarta `undefined`/`''` — nenhum chamador reinventa a regra de omissão.
 */
export function metricsUrl(
  path: string,
  args: Record<string, string | number | boolean | undefined | null> = {},
): string {
  return `${METRICS_PREFIX}/${path}${qs(args)}`;
}
